import { FormControl, UntypedFormControl, Validators } from "@angular/forms";
import { AbstractControl } from "@angular/forms";

/**
 * Form validation regex
 * @type {string}
 */
export const MULTI_EMAIL =
  "^[a-zA-Z0-9.!#$%&*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$";
// export const EMAIL =
//   "^([a-zA-Z0-9_\\-\\.]+)" +
//   "@((\\[[0-9]{1,24}\\.[0-9]{1,24}\\.[0-9]{1,24}\\.)" +
//   "|(([a-zA-Z0-9\\-]+\\.)+))([a-zA-Z]{2,24}|[0-9]{1,24})(\\]?)$";
export const EMAIL =
  "^([a-zA-Z0-9_\\-\\.\\+]+)" +
  "@((\\[[0-9]{1,24}\\.[0-9]{1,24}\\.[0-9]{1,24}\\.)" +
  "|(([a-zA-Z0-9\\-]+\\.)+))([a-zA-Z]{2,24}|[0-9]{1,24})(\\]?)$";

// export const PASSWORD = '(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%]).{5,20}'; //(changes 5 from 6)
// export const PASSWORD = '^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$!%])(?!.*\\])\\S{8,20}$';// not allow to add slash
export const PASSWORD = "^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\\])\\S{8,60}$"; // not allow to add slash
//export const PASSWORD = '^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\\W])(?!.*\\])\\S{8,60}$';// not allow to add slash
// export const PASSWORD = '(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%])(?!.*[\\\\\\/]).{5,20}';// not allow to add slash
export const THRESHOLD = "^[1-9][0-9]?$|^100$";
export const ONLY_DIGIT = "^[0-9]*$";
// export const DOMAIN = '^[a-zA-Z0-9][a-zA-Z0-9-]{0,}[a-zA-Z0-9](?:\\.[a-zA-Z]{2,})+$';
//commenting
// export const DOMAIN = '^[a-zA-Z0-9][a-zA-Z0-9-]{0,}[a-zA-Z0-9](?:\\.[-a-zA-Z]{2,})+$';
//Added newly on 19/09/2018 to validate domain with single charchter at subdomain name
export const DOMAIN =
  "^[a-zA-Z0-9]{0,}[a-zA-Z0-9-]{0,}[a-zA-Z0-9](?:.[-a-zA-Z0-9]{1,})+$";
// export const DOMAIN = '^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\\.[a-zA-Z]{2,})+$';
// export const API = '^(http:\\/\\/www\\.|https:\\/\\/www\\.|http:\\/\\/|https:\\/\\/)' +
//   '[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,24}(:[0-9]{1,24})?(\\/.*)?$';
export const API =
  "^(http://www.|https://www.|http://|https://)?[a-z0-9]+" +
  "([-.]{1}[a-z0-9]+)*.[a-z]{2,5}(:[0-9]{1,5})?(/.*)?|^((http://www.|https://www.|http://|https://)?" +
  "([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]).){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$";
// export const API  = '[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+'
// export const TAG = '\\[%(.*?)\\%]';
export const TAG = "^[0-9a-zA-Z]+$";
export const INBOUND_DOMAIN = "^[0-9a-zA-Z-_]+$";
export const USERNAME = "^([a-zA-Z0-9]){3,34}$";
export const PHONE_NO= "^(\\+\\d{1,2})?\\d{10}$";
// export const COMPANY_TEXT = '^([a-zA-Z0-9\-\s]){3,34}$';
export const COMPANY_TEXT = "^([ a-zA-Z0-9-s._-]){3,34}$";
// export const ALPHA_NUMERIC = '[a-zA-Z0-9\-_]+';
export const ALPHA_NUMERIC = '^[a-z\\d\\A-Z\\d\\-_\\s]+$';
export const ALPHA = '[A-Za-z]{0,50}';
export const URL_REGEX = /^(https?|ftp):\/\/(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+(?::\d{2,5})?(?:\/\S*)?$/;
export const NODOMAINPATTERN = /^(https?:\/\/)?([A-Za-z0-9_-]+\.)*(\-)*\w+(:\d+)?(\/.*)?$/;
export const IPWITHPORTPATTERN=/^(https?:\/\/)?(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}(:\d+)?)(\/.*)?$/;
export const videoUrlRegex = /^(http|https):\/\/(.+)\.(mp4)$/i;
export const documentUrlRegex = /^(http|https):\/\/(.+)\.(pdf)$/i;
export const imgNonGifImage = /^(http|https):\/\/(.+)\.(?:jpe?g|png)$/i
// constant regex for the password policy validation
const UPPERCASE_ALPHABATES = "[A-Z]+";
const LOWERCASE_ALPHABATES = "[a-z]+";
const SPECIAL_CHARCATER = "[ !@#$%^&*()_+\\-=\\[\\]{};':\"|,.<>?]";
// const SPECIAL_CHARCATER = '[ !@#$%^&*()_+\\-=\\[\\]{};\':"\\\\|,.<>\\/?]';
const DIGIT = "[0-9]+";
const SLASH = "[(?!\\\\\\/]";

// export const IP_RANGES = '^((?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))(?:[,-](?1)){0,49}$';
// export const IP_RANGES = '^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\-(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$^(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5])).(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5])).(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5])).(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))(,(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5])).(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5])).(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5])).(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5])))*$';
export const IP_RANGES =
  "^(d|[1-9]d|1dd|2([0-4]d|5[0-5])).(d|[1-9]d|1dd|2([0-4]d|5[0-5])).(d|[1-9]d|1dd|2([0-4]d|5[0-5])).(d|[1-9]d|1dd|2([0-4]d|5[0-5]))(,(d|[1-9]d|1dd|2([0-4]d|5[0-5])).(d|[1-9]d|1dd|2([0-4]d|5[0-5])).(d|[1-9]d|1dd|2([0-4]d|5[0-5])).(d|[1-9]d|1dd|2([0-4]d|5[0-5])))*$";

// export const URL = /^http[s]?:\/\/(www\.)?(.*)?\/?(.)*/;
// export const LATITUDE = /^[-+]?([1-8]?\d(\.\d{1,6})?|90(\.0{1,6})?)$/;
// export const LONGITUDE = /^[-+]?((1[0-7]\d|\d{1,2})(\.\d{1,6})?|180(\.0{1,6})?)$/;

export const LATITUDE = /^[-+]?([1-8]?\d(\.\d{1,7})?|90(\.0{1,7})?)$/;
export const LONGITUDE = /^[-+]?((1[0-7]\d|\d{1,2})(\.\d{1,7})?|180(\.0{1,7})?)$/;

  export class FileValidation {
  /**
   * Validates params for file object
   * @param {number} size Size of the file in bytes
   * @param {string[]} extensions File extension array in lowercase
   */
  constructor(private size: number, private extensions: string[]) {}

  /**
   * Validates given file object
   * @param {File} file
   * @returns {Array} List of errors
   */
  validate(file: File): string[] {
    const fileExtension = this.getExtension(file.name)[0].toLowerCase();
    const fileSize = file.size;
    const errorList = [];
    if (this.extensions.indexOf(fileExtension) === -1) {
      errorList.push(
        "Please upload valid file. (allowed_extensions " +
          this.extensions.join("|") +
          ")"
      );
    }
    if (fileSize > this.size) {
      errorList.push(
        "Exceeded max file size, maximum allowed size is " +
          this.size / 1024 +
          "Kb"
      );
    }
    return errorList;
  }

  getExtension(filename: string) {
    return /[.]/.exec(filename) ? /[^.]+$/.exec(filename) : undefined;
  }
}

export function whiteSpaceIssue(control: UntypedFormControl) {
  const isWhitespace = (control.value || '').trim().length === 0;
  const isValid = !isWhitespace;
  if(control.value && !isValid){
    return {whitespace: true};
  }else if(isValid){
    return null;
  }
}

export class CustomNullValidation {
  constructor() {}

  required(data) {
    if (data.length === 0) {
      return "Field is required";
    }
  }
}

/** One row of the login / file password checklist (same checks as PasswordPolicy.validatePassword). */
export interface LoginPasswordRuleState {
  label: string;
}

// class to validate password policy
export class PasswordPolicy {
  constructor() {}

  /**
   * Rule checklist + submit flag for templates (avoid innerHTML).
   * `passwordFlag` is 0 only when the value matches the PASSWORD pattern.
   */
  getLoginPasswordRuleStates(password: string | null | undefined): {
    rules: LoginPasswordRuleState[];
    passwordFlag: number;
  } {
    const pwd = password ?? "";
    const rules: LoginPasswordRuleState[] = [
      { label: "Min 8 characters" },
      { label: "One uppercase character" },
      { label: "One lowercase  character" },
      { label: "One number" },
    ];
    const policyComplete = Boolean(pwd.match(PASSWORD));
    return {
      rules,
      passwordFlag: policyComplete ? 0 : 1,
    };
  }

  validatePassword(password) {
    // store validation span value
    let passwordPolicyDisp = "";
    // store disable flag value of submit button
    let passwordFlag = 0;

    if (!password.match(PASSWORD)) {
      passwordPolicyDisp = '<ul class="validation-list">';
      // check for the length
      if (password.length < 8) {
        passwordPolicyDisp += "<li>Min 8 characters  </li>";
        passwordFlag = 1;
      } else {
        passwordPolicyDisp += '<li class="fade-label">Min 8 characters  </li>';
      }
      // check for the Upper case
      if (!password.match(UPPERCASE_ALPHABATES)) {
        passwordPolicyDisp += "<li>One uppercase character  </li>";
        passwordFlag = 1;
      } else {
        passwordPolicyDisp +=
          '<li class="fade-label">One uppercase character  </li>';
      }
      // check for the Lower case
      if (!password.match(LOWERCASE_ALPHABATES)) {
        passwordPolicyDisp += "<li>One lowercase  character </li>";
        passwordFlag = 1;
      } else {
        passwordPolicyDisp +=
          '<li class="fade-label">One lowercase  character  </li>';
      }
      // check for the Special case
      // if ((!password.match(SPECIAL_CHARCATER))) {
      //   passwordPolicyDisp += '<li>One special character  </li>';
      //   passwordFlag = 1;
      // } else {
      //   passwordPolicyDisp += '<li class="fade-label">One special character  </li>';
      // }
      // check for the Number
      if (!password.match(DIGIT)) {
        passwordPolicyDisp += "<li>One number  </li>";
        passwordFlag = 1;
      } else {
        passwordPolicyDisp += '<li class="fade-label">One number  </li>';
      }
    } else {
      passwordPolicyDisp =
        '<div class="alert alert-info">Yay! Your password is secure and you are all set.</div>';
      // passwordPolicyDisp = '<li class="form-text text-info">Yay! Your password is secure and you are all set.</li>';
      passwordFlag = 0;
    }
    passwordPolicyDisp += "</ul>";
    return [passwordPolicyDisp, passwordFlag];
  }

  validateAPIPassword(password: string) {
    let passwordPolicyDisp = "";
    let passwordFlag = 0;
  
    // Regex patterns
    const DIGIT = /[0-9]/;
    const UPPERCASE = /[A-Z]/;
    const LOWERCASE = /[a-z]/;
    const SPECIAL = /[!@#$%^&*]/;
  
    passwordPolicyDisp = '<ul class="validation-list2">';
  
    // length check
    if (password.length < 6 || password.length > 16) {
      passwordPolicyDisp += "<li>Length must be between 6 and 16 characters</li>";
      passwordFlag = 1;
    } else {
      passwordPolicyDisp += '<li class="fade-label">Length between 6 and 16 characters</li>';
    }
  
    // uppercase check
    if (!UPPERCASE.test(password)) {
      passwordPolicyDisp += "<li>At least one uppercase character</li>";
      passwordFlag = 1;
    } else {
      passwordPolicyDisp += '<li class="fade-label">At least one uppercase character</li>';
    }
  
    // lowercase check
    if (!LOWERCASE.test(password)) {
      passwordPolicyDisp += "<li>At least one lowercase character</li>";
      passwordFlag = 1;
    } else {
      passwordPolicyDisp += '<li class="fade-label">At least one lowercase character</li>';
    }
  
    // digit check
    if (!DIGIT.test(password)) {
      passwordPolicyDisp += "<li>At least one number</li>";
      passwordFlag = 1;
    } else {
      passwordPolicyDisp += '<li class="fade-label">At least one number</li>';
    }
  
    // special character check
    if (!SPECIAL.test(password)) {
      passwordPolicyDisp += "<li>At least one special character (!@#$%^&*)</li>";
      passwordFlag = 1;
    } else {
      passwordPolicyDisp += '<li class="fade-label">At least one special character (!@#$%^&*)</li>';
    }
  
    passwordPolicyDisp += "</ul>";
  
    // If all good → success message
    if (passwordFlag === 0) {
      passwordPolicyDisp =
        '<div class="alert alert-info">Yay! Your password is secure and you are all set.</div>';
    }
  
    return [passwordPolicyDisp, passwordFlag];
  }
  
}

export const checkLength = (control: AbstractControl) => {
  if (control.value && control.value !== "") {
    const numbers = control.value.split(",");
    if (numbers.length > 5) {
      return { limitexceeded: true };
    }
  }
  return null;
};
export const URL = /^http[s]?:\/\/(www\.)?(.*)?\/?(.)*/;
// export const URL = /^(https?:\/\/)(www\.)?[-a-zA-Z0-9@:%._+~#=,?$&\/]*\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9@:%._+~#=,?$&\/]*)*$/;

export function isValidURL(control: AbstractControl): { [key: string]: boolean } | null {
  if (!NODOMAINPATTERN.test(control.value) && !IPWITHPORTPATTERN.test(control.value))
    return { isValidUrl: true };
  else return null;
}

export const ENGLISH_PUNCTUATION = /^[A-Za-z0-9\s.,!?'"-]*$/;
export const LETTERS_AND_SPACES = /^[A-Za-z0-9\s]+$/;

export const validateEmailIds = function (control: AbstractControl) {
  if (control.value) {
    const mailIds = control.value.split(',');
    let isValid = true;

    mailIds.forEach((email:any) => {
      let trimmedEmail = email.trim();
      if (trimmedEmail) {
        let control = new FormControl(trimmedEmail, Validators.pattern(EMAIL));
        if (control?.hasError('pattern')) {
          isValid = false;
        }
      } else {
        isValid = false;
      }
    });

    if (!isValid) {
      return { invalidEmail: true };
    } else {
      return null;
    }
  }
  return null;
}

export const checkForUptoFiveEmails = function (control: AbstractControl) {
  if (control.value) {
    const mailIds = control.value.split(',');
    if (mailIds.length > 5) {
      return { maxEmail: true };
    }
    return null;
  }
  return null;
}
